import { Box, Typography } from "@mui/material";
import styles from "./services.module.scss";
import GridTableComponent from "../common/GridTableComponent/gridTableTemplate";

interface PoojaItem {
  id?: number | null | undefined;
  name: string | null;
}

const ItemList = [
  { name: "Dr. Kamala Shankar",
  committee:"Human Services",
  phoneNo:"",
  mail:"",
 },
  {
    name: "Peraiah / Nagaraj",
    committee:"Retirement Planning",
    phoneNo:"650-839-1675, 209-769-2111",
  mail:"	peraiahsu@gmail.com",
  },
  {
    name: "Balamani / Anand",
    committee:"Social Activities Trips etc",
    phoneNo:"",
    mail:"",
  },
  {
    name: "Kumar/Kamlesh",
    committee:"Educational Activities",
    phoneNo:"",
    mail:"",
  },
  {
    name: "Dr. Kamala / Peraiah",
    committee:"Health & Wellness",
    phoneNo:"650-839-1675, 209-769-2111",
    mail:"	peraiahsu@gmail.com",
  },
  {
    name: "Kamlesh / Kumar",
    committee:"Nutritional Support",
    phoneNo:"",
    mail:"",
  },
  {
    name: "Dr. Peraiah / Kamlesh",
    committee:" Home Health Services",
    phoneNo:"",
    mail:"",
  },
  {
    name: "Bala Mani/Anand",
    committee:" Transportation",
    phoneNo:"",
    mail:"",
  },
  {
    name: "Kumar / Kamlesh / Peraiah ",
    committee:"End of life issues",
    phoneNo:"650-839-1675, 209-769-2111",
    mail:"	peraiahsu@gmail.com",
  },
];

const columnMapping = {
  name: "Volunteers",
  committee:"Committee",
  phoneNo:"Phone No",
  mail:"Email"
};

const GoldenAgersContactUs = () => {
  return (
    <Box className={styles.ContactUsContainer}>
      <Typography className={styles.mainHeading}>Contact Us</Typography>
      <Box className={styles.detailsContainer}>
        <Typography className={styles.name}>
          Mr. S. Peraiah - Mission Statement
        </Typography>
        <Box className={styles.mailPhoneConatiner}>
          <Box className={styles.mailAndPhone}>
            <img src="/images/phone-call.svg" />
            <Typography className={styles.content}>
              650-839-1675, 209-769-2111
            </Typography>
          </Box>
          <Box className={styles.mailAndPhone}>
            <img src="/images/ic_sharp-email.svg" />
            <Typography className={styles.content}>
              peraiahsu@gmail.com
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box className={styles.table}>
        <div className={styles.tableWrapper}>
          <GridTableComponent
            tableData={ItemList}
            columnMapping={columnMapping}
          />
        </div>
      </Box>
      <Box className={styles.goldenImages}>
        <img src="/images/imageGolden.png" />
        <img src="/images/imageGolden3.png" />
        <img src="/images/imageGolden2.png" />
      </Box>
    </Box>
  );
};

export default GoldenAgersContactUs;
